import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';

// ------------------ Get Notifications -------
const getNotifications = async () => {
    const { data: { data, unread_count } } = await HTTP_CLIENT.get(Endpiont.webhooks.notifications);
    return { data, unread_count };
};

const GetNotificationsQuery = (options = {}) => {
    return useQuery(['Notifications'], () => getNotifications(), {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retry: false,
        ...options
    });
};

// ------------------ Mark All as Read -------
const markNotificationsRead = async () => {
    return await HTTP_CLIENT.patch(Endpiont.webhooks.markRead);
};

const MarkNotificationsReadMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(markNotificationsRead, {
        onSuccess: () => {
            queryClient.invalidateQueries('Notifications');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            toastMessage('error', desc || 'Failed to mark notifications as read');
        }
    });
};

export { GetNotificationsQuery, MarkNotificationsReadMutation };
